import DescriptionIcon from '@mui/icons-material/Description'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField
} from '@mui/material'
import { FC, useContext, useState } from 'react'

import { PromptWithRelated } from '../../../models/inspections'
import { ReplicacheContext } from '../../../providers/ReplicacheProvider/ReplicacheProvider'
import { updateInspectionPromptCache } from '../../../replicache/mutateFunction'

interface Props {
  prompt: PromptWithRelated
  inspectionId: string
}

const OpenNotesDialogCached: FC<Props> = ({ prompt, inspectionId }) => {
  const [open, setOpen] = useState(false)
  const { replicacheInstance } = useContext(ReplicacheContext)
  const handleNotesBlur = (technicianNotes: string) => {
    const updatedPrompt = {
      ...prompt,
      info: { ...prompt.info!, answer: technicianNotes }
    }
    updateInspectionPromptCache(inspectionId, updatedPrompt, replicacheInstance)
  }

  return (
    <>
      <IconButton
        onClick={(event) => {
          event?.stopPropagation()
          setOpen(true)
        }}
        color={!prompt.info!.answer ? 'default' : 'primary'}>
        <DescriptionIcon />
      </IconButton>
      <Dialog open={open} fullWidth maxWidth="sm">
        <DialogTitle>Notes</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            sx={{ mt: 2, mb: 2 }}
            multiline
            minRows={3}
            defaultValue={prompt.info!.answer || ''}
            onBlur={(event) => handleNotesBlur(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default OpenNotesDialogCached
